import { useEffect, useState } from "react";
import { LECTURE_PATH, LECTURE_SUBPATH } from "routes";

import { ILegalLectureTakeView } from "api/education/types";
import { fetchMyLegalLecture as fetchClinicLegalLecture } from "api/clinic/rests";
import { fetchMyLegalLecture as fetchMemberLegalLecture } from "api/member/rests";
import { useUserContext } from "contexts/UserContext";
import LectureAddEmployeePopup from "components/Popups/LectureAddEmployeePopup";
import { USER_TYPE } from "utils/enums";
import { useNavigate } from "react-router-dom";
import { LOGIN_PATH, MAIN_PATH } from "routes";
import { Banner } from "components/commons";

/**
 * 온라인교육 상태값
 * @param take_type
 * @returns 상태 레이블
 */
export const takeTypeToLabel = (
  take_type: string
): { takeCssClass: string; takeLabel: string } => {
  switch (take_type) {
    case "NONE":
      return { takeCssClass: "type-2", takeLabel: "수강 미완료" };
    case "TAKE":
      return { takeCssClass: "type-3", takeLabel: "수강 중" };
    case "COMPLETE":
      return { takeCssClass: "type-1", takeLabel: "수강 완료" };
    default:
      return { takeCssClass: "", takeLabel: "" };
  }
};

const DutyLecturePage = () => {
  const navigate = useNavigate();
  const { isSignIn, userType } = useUserContext();
  const [selectedLecture, setSelectedLecture] =
    useState<ILegalLectureTakeView | null>(null);
  // const { lectures } = useLecturesByCourse("LEGAL");

  const [lectures, setLectures] = useState<ILegalLectureTakeView[]>([]);

  useEffect(() => {
    (async () => {
      const { data } =
        userType === USER_TYPE.개인회원
          ? await fetchMemberLegalLecture()
          : await fetchClinicLegalLecture();

      setLectures(data);
    })();
  }, [userType]);
  useEffect(() => {
    if (!isSignIn) navigate(LOGIN_PATH);
    if (userType === USER_TYPE.개인회원) {
      alert("개인회원은 접근 할 수 없습니다.");
      navigate(MAIN_PATH);
    }
  }, []);

  return (
    <section className="edu-law-list">
      <div className="edu-banner-box type-top">
        <div className="banner-btn">
          <Banner type="LECTURE_LIST" />
        </div>
      </div>
      <div className="edu-law-label-box">
        <div className="bold">※ 참고</div>
        <div>
          노인복지법 제39조의6(노인학대 신고의무와 절차 등) ⓶ 다음 각 호의 어느
          하나에 해당하는 자는 그 직무상 65세 이상의 사람에 대한 노인학대를
          <br />
          알게 된 때에는 즉시 노인보호전문기관 또는 수사기관에 신고하여야 한다.
          1. 의료법 제3조제1항의 의료기관에서 의료업을 행하는 의료인 및
          의료기관의 장, 12. 「의료기사 등에 관한 법률」 제1조의2제1호에 따른
          의료기사
          <br />
          ※ 위반시 500만원 이하의 과태료
          <br />
          <br />
          장애인복지법 제59조의4(장애인학대 및 장애인 대상 성범죄 신고의무와
          절차) ⓶ 다음 각 호의 어느 하나에 해당하는 사람은 그 직무상 장애인학대
          <br />
          및 장애인 대상 성범죄를 알게 된 경우에는 지체 없이 장애인권익옹호기관
          또는 수사기관에 신고하여야 한다. 3. 「의료법」 제2조제1항의 의료인 및
          같은 법 제3조제1항의 의료기관의 장 4. 「의료기사 등에 관한 법률」
          제1조의2의 의료기사
          <br />※ 위반시 300만원 이하의 과태료
        </div>
      </div>
      <div className="edu-law-tit-box">
        <div className="tit-txt">강좌목록</div>
      </div>

      <div className="web-table-box">
        <table>
          <colgroup>
            <col style={{ width: "auto" }} />
            <col style={{ width: "200px" }} />
            <col style={{ width: "200px" }} />
          </colgroup>
          <thead>
            <tr>
              <th>강의명</th>
              <th className="center">수강여부</th>
              <th className="center">수강하기</th>
            </tr>
          </thead>
          <tbody>
            {lectures.map((lecture) => {
              const { takeCssClass, takeLabel } = takeTypeToLabel(
                lecture.take_type
              );
              return (
                <tr key={lecture.lecture_id}>
                  <td>
                    <div className="message-box">
                      <div className="message-txt type-1">{lecture.name}</div>
                    </div>
                  </td>
                  <td className="left">
                    <div className="course-box">
                      <div className="top-box">
                        {lecture.take_type === "COMPLETE" && (
                          <div className="type-txt">
                            {lecture.collect_flag ? "집합교육" : "개별교육"}
                          </div>
                        )}
                        <div className={`state-box ${takeCssClass}`}>
                          {takeLabel}
                        </div>
                      </div>

                      {userType === USER_TYPE.병원회원 &&
                        lecture.take_type === "COMPLETE" && (
                          <div className="bottom-box">
                            {lecture.collect_flag ? (
                              <a
                                href={`${LECTURE_PATH}/${LECTURE_SUBPATH.DUTY}/${lecture.course_id}/personnel`}
                                className="course-btn"
                              >
                                강의명단 바로가기
                              </a>
                            ) : (
                              <a
                                href={`${LECTURE_PATH}/${LECTURE_SUBPATH.MY_DONE}`}
                                className="course-btn"
                              >
                                이수목록 바로가기
                              </a>
                            )}
                          </div>
                        )}
                    </div>
                  </td>
                  <td className="center">
                    <div className="table-option-box">
                      {userType === USER_TYPE.병원회원 && (
                        <div
                          className="table-option-btn"
                          onClick={() => {
                            setSelectedLecture(lecture);
                          }}
                        >
                          집합교육
                        </div>
                      )}
                      <button
                        className="table-option-btn disabled"
                        onClick={() => {
                          navigate(
                            `${LECTURE_PATH}/${LECTURE_SUBPATH.DUTY}/${lecture.course_id}`
                          );
                        }}
                        disabled
                      >
                        개별교육
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="mobile-table-box">
        <div className="item-list">
          {lectures.map((lecture) => {
            const { takeCssClass, takeLabel } = takeTypeToLabel(
              lecture.take_type
            );
            return (
              <div key={lecture.lecture_id} className="item-box">
                <div className="item-top-box">
                  <div className="message-box">
                    <div className="message-txt type-1">{lecture.name}</div>
                  </div>
                </div>

                <div className="item-mid-box">
                  <div className="course-box">
                    <div className="top-box">
                      <div className="type-txt">
                        {lecture.collect_flag ? "집합교육" : "개별교육"}
                      </div>
                      <div className={`state-box ${takeCssClass}`}>
                        {takeLabel}
                      </div>
                    </div>
                  </div>

                  <div className="table-option-box">
                    <div
                      className="table-option-btn"
                      onClick={() => {
                        setSelectedLecture(lecture);
                      }}
                    >
                      집합교육
                    </div>

                    {/* <button
                        onClick={() =>
                          navigate(
                            `${LECTURE_PATH}/${LECTURE_SUBPATH.DUTY}/${lecture.course_id}`
                          )
                        }
                        className="table-option-btn"
                        disabled
                      >
                        개별교육
                      </button>
                     */}
                  </div>
                </div>

                {userType === USER_TYPE.병원회원 &&
                  lecture.take_type === "COMPLETE" && (
                    <div className="quick-box">
                      {lecture.collect_flag ? (
                        <a
                          href={`${LECTURE_PATH}/${LECTURE_SUBPATH.DUTY}/${lecture.course_id}/personnel`}
                          className="quick-btn"
                        >
                          강의명단 바로가기
                        </a>
                      ) : (
                        <a
                          href={`${LECTURE_PATH}/${LECTURE_SUBPATH.MY_DONE}`}
                          className="quick-btn"
                        >
                          이수목록 바로가기
                        </a>
                      )}
                    </div>
                  )}
              </div>
            );
          })}
        </div>
      </div>

      {!!selectedLecture && (
        <LectureAddEmployeePopup
          selected={selectedLecture}
          onClose={() => {
            setSelectedLecture(null);
          }}
        />
      )}
    </section>
  );
};
export default DutyLecturePage;
